/**
 * 固件升级类型定义（对齐 111/firmwareUpgrade.js & upgrading.html）
 */

export type FirmwareTab = 'earphone' | 'earphoneBluetooth' | 'earphoneNoiseCancel' | 'dongle'

export const FIRMWARE_TABS: FirmwareTab[] = [
  'earphone',
  'earphoneBluetooth',
  'earphoneNoiseCancel',
  'dongle',
]

export const VERSION_KEY_MAP: Record<FirmwareTab, string> = {
  earphone: 'softwareVersion',
  earphoneBluetooth: 'bluetoothVersion',
  earphoneNoiseCancel: 'noiseCancelVersion',
  dongle: 'dongleVersion',
}

export const FIRMWARE_FOLDER_MAP: Record<FirmwareTab, string> = {
  earphone: 'Earphone',
  earphoneBluetooth: 'EarphoneBluetooth',
  earphoneNoiseCancel: 'EarphoneNoiseCancel',
  dongle: 'Dongle',
}

export interface FirmwareMockItem {
  deviceName: string
  latestVersion: string
  size: string
  description: string
  historyList: Array<{
    version: string
    fileName?: string
    description: string
    update_date?: string
    updateDate?: string
    date?: string
  }>
}

export interface UpgradeCallbacks {
  onProgress?: (percent: number, message: string) => void
  onComplete?: () => void
  onError?: (error: Error) => void
  onLog?: (message: string, level?: string) => void
}

export type OtaState =
  | 'idle'
  | 'entering_boot'
  | 'waiting_boot'
  | 'transferring'
  | 'completed'
  | 'failed'
